class FounderHeroMedia extends HTMLElement {
  connectedCallback() {
    this.img = this.querySelector('img');
    this.badge = this.querySelector('.founder-hero__badge');
    this.fetchMedia();
  }
  
  async fetchMedia() {
    try {
      const res = await fetch('/apps/seifeops/storefront/founder/media');
      if (!res.ok) return;
      const data = await res.json();
      if (data && data.length > 0) {
        // Hero is the first media item
        const hero = data[0];
        if (hero.imageUrl && this.img) {
          this.img.src = hero.imageUrl;
          if (hero.alt) this.img.alt = hero.alt;
        }
      }
    } catch (e) {
      console.error(e);
    }
  }
}
customElements.define('founder-hero-media', FounderHeroMedia);

class FounderMediaList extends HTMLElement {
  connectedCallback() {
    this.playBtn = this.querySelector('button.founder-story-card');
    this.btnImg = this.playBtn?.querySelector('img');
    this.btnTitle = this.playBtn?.querySelector('strong');
    this.btnSub = this.playBtn?.querySelector('small');
    this.btnPlayText = this.playBtn?.querySelector('.founder-story-card__cta');
    this.note = this.querySelector('.founder-media-list__note');
    this.clips = this.querySelector('[data-founder-clips]');
    this.closeLabel = this.getAttribute('data-close-label') || '';
    this.playLabel = this.getAttribute('data-play-label') || '';
    this.mediaItems = [];
    
    this.playBtn?.addEventListener('click', () => this.openModal(this.mediaItems[0]));
    this.fetchMedia();
  }

  async fetchMedia() {
    try {
      const res = await fetch('/apps/seifeops/storefront/founder/media');
      if (!res.ok) return;
      const data = await res.json();
      // Keep only items that have videoUrl or embedUrl
      this.mediaItems = data.filter(m => m.videoUrl || m.embedUrl);
      
      if (this.mediaItems.length === 0) {
        this.style.display = 'none'; // hide if no videos
        return;
      }
      
      // Update first item in the card
      const primary = this.mediaItems[0];
      if (primary.imageUrl && this.btnImg) {
        this.btnImg.src = primary.imageUrl;
        if (primary.alt) this.btnImg.alt = primary.alt;
      }
      if (primary.title && this.btnTitle) this.btnTitle.textContent = primary.title;
      if (primary.subtitle && this.btnSub) this.btnSub.textContent = primary.subtitle;
      
      // Update note for additional clips
      if (this.mediaItems.length > 1 && this.note) {
        const otherTitles = this.mediaItems.slice(1).map(m => m.title).join(' · ');
        const prefix = this.getAttribute('data-more-clips') || '';
        this.note.textContent = [prefix, otherTitles].filter(Boolean).join(' ');
      }

      if (this.clips) {
        this.clips.replaceChildren();
        this.mediaItems.slice(1).forEach(media => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'founder-media-list__clip';
          button.textContent = [this.playLabel, media.title].filter(Boolean).join(' · ');
          button.addEventListener('click', () => this.openModal(media));
          this.clips.appendChild(button);
        });
      }
      
    } catch (e) {
      console.error(e);
    }
  }

  openModal(media) {
    if (!media) return;
    
    // accessible modal setup
    const modal = document.createElement('div');
    modal.className = 'founder-video-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'founder-video-title');
    
    const backdrop = document.createElement('div');
    backdrop.className = 'founder-video-modal-backdrop';
    
    const content = document.createElement('div');
    content.className = 'founder-video-modal-content';
    
    const title = document.createElement('h2');
    title.id = 'founder-video-title';
    title.className = 'visually-hidden';
    title.textContent = media.title;
    
    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'founder-video-modal-close';
    closeBtn.setAttribute('aria-label', this.closeLabel || media.title);
    closeBtn.textContent = '✕';
    
    const wrapper = document.createElement('div');
    wrapper.className = 'founder-video-modal-wrapper';
    
    let mediaEl;
    if (media.embedUrl) {
      mediaEl = document.createElement('iframe');
      mediaEl.src = media.embedUrl;
      mediaEl.setAttribute('frameborder', '0');
      mediaEl.setAttribute('allow', 'autoplay; fullscreen');
      mediaEl.setAttribute('allowfullscreen', 'true');
      mediaEl.setAttribute('title', media.title);
    } else {
      mediaEl = document.createElement('video');
      mediaEl.src = media.videoUrl;
      mediaEl.controls = true;
      mediaEl.autoplay = true;
      mediaEl.setAttribute('aria-label', media.title);
    }
    
    wrapper.appendChild(mediaEl);
    content.appendChild(title);
    content.appendChild(closeBtn);
    content.appendChild(wrapper);
    modal.appendChild(backdrop);
    modal.appendChild(content);
    
    document.body.appendChild(modal);
    
    // focus trap & cleanup
    const originalFocus = document.activeElement;
    closeBtn.focus();
    document.body.style.overflow = 'hidden';
    
    const cleanup = () => {
      document.body.style.overflow = '';
      modal.remove();
      if (originalFocus) originalFocus.focus();
    };
    
    closeBtn.addEventListener('click', cleanup);
    backdrop.addEventListener('click', cleanup);
    
    modal.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        cleanup();
        return;
      }
      if (e.key === 'Tab') {
        const focusables = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), video, iframe');
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        
        if (e.shiftKey) {
          if (document.activeElement === first) {
            last.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === last) {
            first.focus();
            e.preventDefault();
          }
        }
      }
    });
  }
}
customElements.define('founder-media-list', FounderMediaList);

class PressCoverageSection extends HTMLElement {
  connectedCallback() {
    this.kicker = this.getAttribute('data-kicker');
    this.fetchPress();
  }
  
  async fetchPress() {
    try {
      const res = await fetch('/apps/seifeops/storefront/founder/press');
      if (!res.ok) return;
      const data = await res.json();
      if (data && data.length > 0) {
        this.render(data);
      } else {
        this.style.display = 'none';
      }
    } catch (e) {
      console.error(e);
      this.style.display = 'none';
    }
  }
  
  render(pressItems) {
    const container = document.createElement('div');
    container.className = 'page-width';
    
    const header = document.createElement('p');
    header.className = 'mono text-center';
    header.textContent = this.kicker;
    
    const grid = document.createElement('div');
    grid.className = 'founder-press__grid mt-6';
    
    pressItems.forEach(item => {
      const link = document.createElement('a');
      link.className = 'founder-press__card';
      link.href = item.externalUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = '«' + item.quote + '» — ' + item.publication;
      grid.appendChild(link);
    });
    
    container.appendChild(header);
    container.appendChild(grid);
    this.appendChild(container);
  }
}
customElements.define('press-coverage-section', PressCoverageSection);
